import {
    createBaseQueries,
    transformErrorResponse,
    transformSuccessResponse,
    transformRequest,
    buildFormData,
    EXTERNAL_URL
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const { rawExternalApiBaseQuery: menuAPIBaseQuery } = createBaseQueries({
    externalURLType: EXTERNAL_URL.appRoot,
});

const menuAPI = createApi({
    reducerPath: "menuAPI",
    baseQuery: menuAPIBaseQuery,
    endpoints: (builder) => ({
        getMenus: builder.query({
            query: (params) => {
                let queryParams = params;
                if (typeof params === "number" || typeof params === "string") {
                    queryParams = { moduleId: params };
                }
                return {
                    url: "/util/menus",
                    method: "GET",
                    params: queryParams,
                };
            },
            transformResponse: (response, meta, arg) => transformSuccessResponse(response, meta, arg),
            transformErrorResponse: (response, meta, arg) => transformErrorResponse(response, meta, arg),
        }),
    }),
});

export const { useGetMenusQuery, useLazyGetMenusQuery } = menuAPI;
export default menuAPI;

